import React from 'react';

import styles from './styles.module.scss';

function GridGuides() {
  const columns = [...new Array(12)]
    .map((_, index) => <div key={index.toString()} className={styles.gridColumn} />);

  return (
    <div className={`gridGuides ${styles.grid}`}>
      <div className={styles.gridColumns}>
        {columns}
      </div>
    </div>
  );
}

export default GridGuides;
